import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { MapPin, X } from "lucide-react";

export const ComuneSearch = ({ value, onSelect, inputCls, testId = "filter-place" }) => {
  const [q, setQ] = useState(value?.name || "");
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  useEffect(() => { setQ(value ? `${value.name} (${value.prov})` : ""); }, [value]);

  const type = (v) => {
    setQ(v);
    clearTimeout(timer.current);
    if (v.trim().length < 2) { setOpts([]); return; }
    timer.current = setTimeout(() => api.get("/geo/comuni", { params: { q: v } }).then((r) => { setOpts(r.data); setOpen(true); }), 150);
  };
  const pick = (c) => { setOpen(false); setOpts([]); onSelect(c); };

  return (
    <div className="relative">
      <input data-testid={testId} value={q} onChange={(e) => type(e.target.value)} onFocus={() => opts.length && setOpen(true)}
        onKeyDown={(e) => { if (e.key === "Enter" && opts[0]) { e.preventDefault(); pick(opts[0]); } }}
        onBlur={() => setTimeout(() => setOpen(false), 150)} placeholder="Comune o provincia (es. Avellino)" className={`${inputCls} pr-9`} autoComplete="off"/>
      {value && <button type="button" data-testid="filter-place-clear" onClick={() => { setQ(""); onSelect(null); }} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-navy" aria-label="Cancella comune"><X className="w-4 h-4"/></button>}
      {open && opts.length > 0 && (
        <ul className="absolute z-30 mt-1 w-full bg-white border border-slate-200 rounded-2xl shadow-xl max-h-72 overflow-y-auto py-1" data-testid="place-options">
          {opts.map((c) => (
            <li key={`${c.name}-${c.prov}`}>
              <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => pick(c)} data-testid={`place-opt-${c.name}`} className="w-full text-left px-4 py-2 text-sm hover:bg-gold/10 flex items-center gap-2">
                <MapPin className="w-3.5 h-3.5 text-gold shrink-0"/><span className="font-semibold">{c.name}</span><span className="text-slate-500">({c.prov}) · {c.region}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
